module.exports = __webpack_public_path__ + "img/modern_black_leather_suit-400x520.e877fa89.jpg";